<template>
  <Select
    :model-value="modelValue"
    :label="t('invoicingTypeLabel')"
    :options="options"
    :disabled="disabled || options.length <= 1"
    @update:model-value="handleUpdate"
  />
</template>

<script lang="ts" setup>
import Select from '@/components/Select.vue';
import { InvoicingType } from '@/entities/bookings/invoicing-type.enum';
import { uniq } from 'lodash';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  modelValue: InvoicingType;
  allowedInvoicingTypes: InvoicingType[];
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: InvoicingType): void;
}>();

const { t } = useI18n();

const handleUpdate = (value: string | null | undefined) => {
  if (!value || !props.allowedInvoicingTypes.includes(value as InvoicingType)) {
    return;
  }
  emit('update:modelValue', value as InvoicingType);
};

const options = computed(() =>
  uniq([props.modelValue, ...props.allowedInvoicingTypes]).map((value) => ({
    value,
    label: t(`invoicingType.${value}`),
  })),
);
</script>

<i18n lang="json">
{
  "en": {
    "invoicingTypeLabel": "Invoicing mode"
  },
  "de": {
    "invoicingTypeLabel": "Abrechnungsmodus"
  },
  "es": {
    "invoicingTypeLabel": "Modo de facturación"
  }
}
</i18n>
